<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner" class="content">
  <app-menu></app-menu>
  <mat-card class="equipe-card">
    <mat-card-title class="equipe-titulo">
      <div style="text-align: center;">
        <h1>Equipes</h1>
      </div>
    </mat-card-title>
    <mat-card-content>

      <div *ngIf="liberarCriacaoEquipe">
        <!--Criar equipe-->
        <mat-card class="criar-equipe-card">
          <mat-card-title class="criar-equipe-titulo">
            <h2>Criar uma equipe</h2>
          </mat-card-title>

          <mat-card-content>
            <mat-form-field style="width: 100%">
              <input matInput placeholder="Digite o nome da sua equipe aqui" [(ngModel)]="nomeNovaEquipe" (keydown.enter)="criarEquipe()">
            </mat-form-field>
          </mat-card-content>

          <mat-card-actions align="end">
            <button mat-flat-button (click)="criarEquipe()">Criar</button>
          </mat-card-actions>
        </mat-card>
      </div>

      <!-- Entrar em equipe já existente -->
      <mat-card class="equipes-card">
        <mat-card-title class="equipes-titulo">
          <h2> Entrar em equipe já criada </h2>
        </mat-card-title>

        <mat-card-content>

          <mat-card class="equipes-list-card" *ngFor="let equipe of getEquipes()">
            <mat-card-title class="equipes-list-titulo">
              <h3> {{equipe.nomeEquipe}} </h3>
            </mat-card-title>

            <mat-card-content>
              <p>Desafio escolhido: {{equipe.desafioEscolhido.titulo}}</p>

              <p><b>Membros:</b></p>
              <div *ngFor="let membro of equipe.membros">
                <ul>
                  {{membro.displayName}}
                </ul>
              </div>

            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-flat-button (click)="entrarNaEquipe(equipe)">Entrar</button>
            </mat-card-actions>
          </mat-card>

        </mat-card-content>
      </mat-card>

    </mat-card-content>
  </mat-card>
</div>


